import { OptionTile } from "@manifesthhqinc/ui-library";
import { TitleLarge } from "../../../components/font";
import TransitionWrapper from "../../../components/transition-wrapper/TransitionWrapper";
import Container from "../../../layout/container";
import ScrollableContainer from "../../../layout/scrollable-container";
import { OptionTileContainer } from "./styles";
import {
  FeeAcceptanceForManagement,
  FinancialDecisionValue,
  InvestmentOptionsPreference,
  UseHenryQuestionniareProps,
} from "../useHenryQuestionnaire";
import {
  STEP_DESTINATION_HELP_6A,
  STEP_DESTINATION_HELP_6B,
  STEP_DESTINATION_HELP_6C,
} from "../../../class/transferDetails";
import HeadingContainer from "../../../layout/heading-container";

const getHeading = (screen: string): string => {
  if (screen === STEP_DESTINATION_HELP_6A) {
    return "When making financial decisions, what do you value most?";
  }
  if (screen === STEP_DESTINATION_HELP_6B) {
    return "Would you want your account to manage things like risk and rebalancing for a small fee?";
  }
  if (screen === STEP_DESTINATION_HELP_6C) {
    return "Do you care about having a wider range of investment options?";
  }
  return "";
};

const HenryQuestionnaireSix = (props: UseHenryQuestionniareProps) => {
  const { updateHenryQuestionnaire, currentScreen } = props;
  const renderContent = () => {
    if (currentScreen === STEP_DESTINATION_HELP_6A) {
      return (
        <>
          <OptionTile
            name="peace"
            variant="clickthrough"
            appearance="secondary"
            onClick={() => updateHenryQuestionnaire({ financialDecisionValue: FinancialDecisionValue.PEACE_OF_MIND })}
          >
            Peace of mind — I don’t want to worry about it
          </OptionTile>
          <OptionTile
            variant="clickthrough"
            appearance="secondary"
            onClick={() => updateHenryQuestionnaire({ financialDecisionValue: FinancialDecisionValue.CONTROL })}
            name="control"
          >
            Control — I want to understand and steer it myself
          </OptionTile>
          <OptionTile
            name="simplicity"
            variant="clickthrough"
            appearance="secondary"
            onClick={() => updateHenryQuestionnaire({ financialDecisionValue: FinancialDecisionValue.SIMPLICITY })}
          >
            Simplicity — I just want something that works
          </OptionTile>
        </>
      );
    }
    if (currentScreen === STEP_DESTINATION_HELP_6B) {
      return (
        <>
          <OptionTile
            name="yes"
            variant="clickthrough"
            appearance="secondary"
            onClick={() =>
              updateHenryQuestionnaire({ feeAcceptanceForManagement: FeeAcceptanceForManagement.VALUE_HELP })
            }
          >
            Yes, I’d value the help
          </OptionTile>
          <OptionTile
            name="no"
            variant="clickthrough"
            appearance="secondary"
            onClick={() => updateHenryQuestionnaire({ feeAcceptanceForManagement: FeeAcceptanceForManagement.UNSURE })}
          >
            I’m not sure yet
          </OptionTile>
          <OptionTile
            name="no"
            variant="clickthrough"
            appearance="secondary"
            onClick={() =>
              updateHenryQuestionnaire({ feeAcceptanceForManagement: FeeAcceptanceForManagement.AVOID_FEES })
            }
          >
            I’d rather avoid fees if I can
          </OptionTile>
        </>
      );
    }
    if (currentScreen === STEP_DESTINATION_HELP_6C) {
      return (
        <>
          <OptionTile
            name="yes"
            variant="clickthrough"
            appearance="secondary"
            onClick={() =>
              updateHenryQuestionnaire({ investmentOptionsPreference: InvestmentOptionsPreference.FULL_CONTROL })
            }
          >
            Yes — I want full control over where the money goes
          </OptionTile>
          <OptionTile
            name="no"
            variant="clickthrough"
            appearance="secondary"
            onClick={() =>
              updateHenryQuestionnaire({ investmentOptionsPreference: InvestmentOptionsPreference.SMALLER_LIST_OK })
            }
          >
            No — I’m fine picking from a smaller list
          </OptionTile>
          <OptionTile
            name="no"
            variant="clickthrough"
            appearance="secondary"
            onClick={() =>
              updateHenryQuestionnaire({ investmentOptionsPreference: InvestmentOptionsPreference.UNSURE })
            }
          >
            I’m not sure / doesn’t matter much
          </OptionTile>
        </>
      );
    }
    return <></>;
  };
  return (
    <TransitionWrapper>
      <ScrollableContainer name="henry-questionnaire-form-1">
        <Container>
          <HeadingContainer paneVariant="optionForm" withProgressBar>
            <TitleLarge>{getHeading(currentScreen)}</TitleLarge>
          </HeadingContainer>
          <OptionTileContainer>{renderContent()}</OptionTileContainer>
        </Container>
      </ScrollableContainer>
    </TransitionWrapper>
  );
};
export default HenryQuestionnaireSix;
